<template>
  <div class="media container">
    <b-row>
      <b-col class="media-item">
        <link-prevue
          url="http://voyagemia.com/interview/meet-trailblazer-shani-coaching/?fbclid=IwAR1lBm6s77Ao1AMRQntDdIiftI6pSwmwwT_AWjQB1E4XIyxpHvw9UqGl_wc"
        >
          <template slot-scope="props">
            <slot
              :img="shaniImg"
              :title="props.title"
              :description="props.description"
              :url="url"
            >
              <div class="wrapper">
                <img
                  class="card-img-top card-img"
                  :src="shaniImg"
                  :alt="props.title"
                />
                <div class="card-block">
                  <div class="card-info">
                    <div class="card-text">
                      <h1>
                        Meet Trailblazer Shani Coaching - Voyage MIA Magazine |
                        Miami City Guide
                      </h1>
                      <p>
                        <!-- {{ props.description }} -->
                        Today we’d like to introduce you to Shani Coaching.
                        Shani, let’s start with your story. We’d love to hear
                        how you got started and how the journey has been so far.
                        Upon graduating with my BA degree in Vienna, Austria, I
                        started working for a known global IT corporate in their
                        European HQ, I progressed...
                      </p>
                      <div class="card-btn-wrap">
                        <a v-bind:href="props.url" target="_blank">
                          <button class="button btn-filled-white">
                            View More
                          </button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </slot>
          </template>
        </link-prevue>
      </b-col>
      <b-col class="media-item">
        <link-prevue
          cardWidth="400px"
          url="https://podcasts.apple.com/us/podcast/change-your-preception-to-change-your-direction-shani/id1451616710?i=1000449272507&fbclid=IwAR0jbXQce1bvRguHYp8Dp7vAmeYYMYZfV-lFls-KADrStfPkSclVUWqfwj8"
        >
          <template slot-scope="props">
            <slot
              :img="brainBoomImg"
              :title="props.title"
              :description="props.description"
              :url="url"
            >
              <div class="wrapper">
                <img
                  class="card-img-top card-img"
                  :src="brainBoomImg"
                  :alt="props.title"
                />
                <div class="card-block">
                  <div class="card-info">
                    <div class="card-text">
                      <h1>
                        Brain Boom with Matt West: Change your Preception to
                        change your direction with Shani | Ep.75 on Apple
                        Podcasts
                      </h1>
                      <!-- <p>{{ props.description }}</p> -->
                      <p>
                        Show Brain Boom with Matt West | Ep.75 - Sep 10, 2019
                      </p>
                      <p>
                        In episode 75 Shani shares how she changed her
                        perception on her life and how she supports others to do
                        as well. Tune in to hear the tips on the different daily
                        tips you learn to apply to your life on your path to
                        self-improvement.
                      </p>
                      <div class="card-btn-wrap">
                        <a v-bind:href="props.url" target="_blank">
                          <button class="button btn-filled-white">
                            View More
                          </button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </slot>
          </template>
        </link-prevue>
      </b-col>
    </b-row>

    <!-- <b-row>
      <b-col class="d-block d-lg-none">
        <link-prevue
          cardWidth="300px"
          url="http://voyagemia.com/interview/meet-trailblazer-shani-coaching/?fbclid=IwAR1lBm6s77Ao1AMRQntDdIiftI6pSwmwwT_AWjQB1E4XIyxpHvw9UqGl_wc"
        ></link-prevue>
      </b-col>
      <b-col class="d-block d-lg-none">
        <link-prevue
          style="margin-top: 3vh;"
          cardWidth="300px"
          url="https://www.kasoziassociates.com/post/2019/08/11/spotlight-series-meet-career-fulfillment-coach-shani?fbclid=IwAR3Av8YM_rHdfDvX9kEIV3aLxIDQFZp8ZEi6L2AwDPpmsGpQDQwZKaUt3O0"
        ></link-prevue>
      </b-col>
      <b-col class="d-block d-lg-none">
        <link-prevue
          style="margin-top: 3vh;"
          cardWidth="300px"
          url="https://podcasts.apple.com/us/podcast/change-your-preception-to-change-your-direction-shani/id1451616710?i=1000449272507&fbclid=IwAR0jbXQce1bvRguHYp8Dp7vAmeYYMYZfV-lFls-KADrStfPkSclVUWqfwj8"
        ></link-prevue>
      </b-col>
    </b-row> -->
  </div>
</template>

<script>
import LinkPrevue from "link-prevue";
import brainBoomImg from "../assets/brain-boom1.jpg";
import shaniImg from "../assets/media-pg-image-1.jpg";

export default {
  name: "Media",
  data() {
    return {
      brainBoomImg,
      shaniImg,
    };
  },
  components: {
    LinkPrevue,
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss">
.media {
  margin: 5em auto;
  .row {
    display: flex;
    flex-direction: column;

    @media screen and (min-width: 481px) {
      padding: 0 3em;
    }

    @media screen and (min-width: 768px) {
      flex-direction: row;
    }
  }
}
.wrapper {
  height: 100%;
  margin-top: 38px;
  overflow: auto;
  border-radius: 7px 7px 7px 7px;
  background-color: #fff;
  -webkit-box-shadow: 0px 14px 32px 0px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 0px 14px 32px 0px rgba(0, 0, 0, 0.15);
  box-shadow: 0px 14px 32px 0px rgba(0, 0, 0, 0.15);
  @media screen and (min-width: 768px) {
    margin-top: 0;
  }
}

.media-item {
  display: flex;
  justify-content: center;
}

.card-btn-wrap {
  position: relative;
  text-align: center;
  margin-top: 4vh !important;
}

.card-text h1 {
  text-align: center;
  font-size: 24px;
  color: #474747;
  margin: 5px 0 20px 0 !important;
  font-family: "Hind Siliguri", sans-serif;
}
.card-text p {
  font-family: "Hind Siliguri", sans-serif;
  color: #8d8d8d;
  font-size: 15px;
  overflow: hidden;
  margin: 0;
  text-align: center;
}

.card-info {
  border-radius: 0 0 7px 7px;
  background-color: #ffffff;
  margin: 4vh 0;
}
.card-img {
  flex-shrink: 0;
  width: 100%;
  margin-left: 0px !important;

  img {
    width: 100%;
    border-radius: 7px 7px 0 0;
  }
}
</style>
